<template>
	<div class="basic_wrap">
		<div class="header-title">
			<van-icon name="arrow-left" class="back-icon" @click="$router.back()" />
			{{ hasRealInfo ? '实名信息' : '实名认证' }}
		</div>
		<form class="form" @submit.prevent="submit">
			<div class="tittle_verified">
				{{ hasRealInfo ? '查看身份信息' : '填写身份信息' }}
			</div>
			<div class="notice-text">
				{{ hasRealInfo ? '您的实名信息已认证，如有错误请联系客服修改' : '您的个人信息将被严格保密，仅用于实名认证' }}
			</div>

			<!-- 实名状态提示 -->
			<div v-if="hasRealInfo" class="auth-status">
				<van-icon name="passed" color="#07c160" />
				<span class="status-text">已实名认证</span>
			</div>

			<div class="item">
				<div class="ari_font">
					真实姓名
				</div>
				<input v-model="datas.name" class="card" type="text" :placeholder="hasRealInfo ? '' : '请输入真实姓名'"
					:disabled="hasRealInfo" :class="{ 'disabled-input': hasRealInfo }">
			</div>
			<div class="item">
				<div class="ari_font">
					证件类型
				</div>
				<input value="身份证" class="card" type="text" disabled>
			</div>
			<div class="item">
				<div class="ari_font">
					证件号码
				</div>
				<input v-model="datas.idcard" class="card" type="text" :placeholder="hasRealInfo ? '' : '请输入证件号码'"
					:disabled="hasRealInfo" :class="{ 'disabled-input': hasRealInfo }">
			</div>

			<!-- 提交按钮（仅在未实名时显示） -->
			<button v-if="!hasRealInfo" type="submit" class="basic_btn sbtn"
				:class="!datas.name || !datas.idcard ? 'no_touch' : ''">
				{{ $t('authEmail.submit') }}
			</button>

			<!-- 已实名时的提示 -->
			<div v-if="hasRealInfo" class="real-tips">
				如需修改实名信息，请联系客服处理
			</div>
		</form>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		CountDown,
		Checkbox
	} from "vant";
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index";
	import bsHeader from '../../components/bsHeader.vue';
	import {
		Overlay,
		Uploader,
		Button,
		DropdownMenu,
		DropdownItem,
		Toast,
		Icon
	} from 'vant';
	import axios from 'axios'

	Vue.use(CountDown)
		.use(Checkbox)
		.use(Icon);

	export default {
		name: "Setpwd",
		components: {
			bsHeader
		},
		data() {
			return {
				data: {},
				datas: {
					name: '',
					img: '',
					back_img: '',
					idcard: ''
				},
				time: 0,
				code: '',
				previewImageUrl: "",
				previewImageUrl2: "",
				hasRealInfo: false, // 是否已有实名信息
				authStatus: 0 // 实名状态 0-未实名 1-已实名
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				// 获取用户基本信息
				Fetch('/user/info').then((r) => {
					this.data = r.data;
				});

				// 获取实名信息
				this.getRealInfo();
			},

			// 获取实名信息
			getRealInfo() {
				Fetch('/user/real_info').then((r) => {
					if (r.code === 1) {
						const realData = r.data;
						this.authStatus = realData.auth || 0;
						this.hasRealInfo = realData.auth == 1;

						if (this.hasRealInfo && realData.name && realData.idcard) {
							// 已有实名信息，填充数据
							this.datas.name = realData.name;
							this.datas.idcard = realData.idcard;

							this.$toast({
								type: 'success',
								message: '已加载实名信息'
							});
						}
					}
				}).catch(() => {
					// 获取失败，视为未实名
					this.hasRealInfo = false;
				});
			},

			submit() {
				// 如果已有实名信息，禁止提交
				if (this.hasRealInfo) {
					this.$toast('您已实名认证，无需重复提交');
					return false;
				}

				// 身份证号验证
				const idcardReg = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
				if (!idcardReg.test(this.datas.idcard)) {
					this.$toast('证件号码格式不正确');
					return false;
				}
				if (!this.datas.name) {
					this.$toast('请输入真实姓名');
					return false;
				}
				if (!this.datas.idcard) {
					this.$toast({
						className: "toastName",
						message: '请输入证件号码',
					});
					return false;
				}

				// 提交实名认证
				Fetch('/user/real_add', {
					...this.datas
				}).then(r => {
					if (r.code === 1) {
						this.$toast({
							type: 'success',
							message: r.info || '实名认证成功',
							onClose: () => {
								// 重新加载实名信息
								this.getRealInfo();
								// 延迟返回，让用户看到成功提示
								setTimeout(() => {
									this.$router.go(-1);
								}, 1500);
							}
						});
					}
				}).catch(err => {
					this.$toast(err.info || '提交失败');
				});
			},

			timeCall() {
				this.is_send = false;
				this.time = 0;
			},

			sendcode() {
				if (this.is_send) {
					return;
				}
				this.is_send = true;

				Fetch("/index/auth_email_code").then(() => {
						this.time = 60 * 1000;
						this.$toast({
							background: "#07c160",
							message: this.$t('authEmail.sendsuccess'),
						});
					})
					.catch(() => {
						this.is_send = false;
					});
			},
		}
	};
</script>

<style lang="less" scoped>
	.basic_wrap {
		height: 100vh;
		background-color: #fff;
	}

	.tittle_verified {
		margin-top: 40px;
		margin-bottom: 20px;
		font-size: 24px;
		font-weight: bold;
		color: #333;
	}

	.notice-text {
		color: #999;
		font-size: 14px;
		margin-bottom: 30px;
		line-height: 1.5;
	}

	.form {
		width: 100%;
		margin-top: 32px;
		padding: 0 20px;

		.auth-status {
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 20px 0 30px;
			padding: 10px;
			background-color: #f0f9eb;
			border-radius: 8px;
			border: 1px solid #e1f3d8;

			.status-text {
				margin-left: 8px;
				color: #07c160;
				font-weight: 500;
				font-size: 16px;
			}
		}

		.item {
			width: 100%;
			height: 45px;
			border-radius: 2px;
			border-bottom: 1px solid rgba(0, 0, 0, 0.1);
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin: 40px 0;
			position: relative;

			input {
				flex: 1;
				padding: 0 10px;
				height: 22px;
				font-size: 16px;
				line-height: 22px;
				background: transparent;
				border: none;
				color: #333;
			}

			.masked-idcard {
				position: absolute;
				right: 10px;
				top: 50%;
				transform: translateY(-50%);
				color: #666;
				font-size: 16px;
				pointer-events: none;
				z-index: 2;
			}
		}

		.basic_btn {
			width: 100%;
			margin-top: 30px;
			height: 44px;
			background: linear-gradient(135deg, #ff6b6b, #ee5a52);
			border: none;
			border-radius: 22px;
			color: white;
			font-size: 16px;
			font-weight: 500;

			&.no_touch {
				background: #ccc;
				pointer-events: none;
			}

			&:active {
				opacity: 0.9;
			}
		}

		.real-tips {
			margin-top: 30px;
			text-align: center;
			color: #999;
			font-size: 14px;
			padding: 10px;
			background-color: #f8f8f8;
			border-radius: 8px;
		}
	}

	.header-title {
		position: relative;
		z-index: 1;
		width: 100%;
		text-align: center;
		font-size: 4.8vw;
		font-weight: 600;
		padding: 4vw 0;
		background: #fff;
		box-shadow: 0 1.06667vw 3.2vw rgba(0, 0, 0, .05);
		color: #333;
		border-bottom: 1px solid rgba(0, 0, 0, .05);

		.back-icon {
			position: absolute;
			left: 4vw;
			top: 50%;
			transform: translateY(-50%);
			font-size: 5.33333vw;
			color: #333;
		}
	}
</style>